package com.essntl.features.proposal.ui.selectservice

import com.essntl.features.proposal.domain.model.ProposalServiceModel
import com.essntl.features.service.domain.model.service.ServiceFilterOptions
import com.essntl.features.service.domain.model.service.ServiceModel

sealed interface SelectServiceEvent {
    data class ProposalServiceChanged(val proposalService: ProposalServiceModel?) : SelectServiceEvent
    data class OpenProposalPreview(val previewLink: String?) : SelectServiceEvent
    data class AddService(val service: ServiceModel) : SelectServiceEvent
    data class EditService(val service: ServiceModel) : SelectServiceEvent
    data class FilterServices(val filterOptions: ServiceFilterOptions) : SelectServiceEvent
    data object GetAllService: SelectServiceEvent
    data object LoadMoreServices: SelectServiceEvent
}